import React, { useState, useEffect } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';

// ログイン後に表示されるメインのアプリケーションコンポーネント
function MainApp({ signOut, user }) {
  const [embedUrl, setEmbedUrl] = useState('');
  const [message, setMessage] = useState('Now Loading...');
  const [idToken, setIdToken] = useState('');

  useEffect(() => {
    const getEmbedUrl = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        if (!token) {
          throw new Error('ID token is not available.');
        }
        setIdToken(token); // トークンをstateに保存

        // バックエンドAPIにIDトークンを添えてリクエスト
        // YOUR_BACKEND_API_ENDPOINT は実際のAPIエンドポイントに置き換えてください
        const response = await fetch('YOUR_BACKEND_API_ENDPOINT/get-dashboard-url', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch embed URL from backend');
        }

        const data = await response.json();
        setEmbedUrl(data.EmbedUrl);
        setMessage('Dashboard loaded successfully!');
      } catch (error) {
        console.error('Error:', error);
        setMessage(`Error: ${error.message}`);
      }
    };

    if (user) {
      getEmbedUrl();
    }
  }, [user]); // userオブジェクトが利用可能になったら実行

  return (
    <div>
      <h1>QuickSight-Viewer</h1>
      <p>Hello, {user.username}!</p>
      <button onClick={signOut}>Sign Out</button>
      <hr />
      <p>{message}</p>
      {embedUrl ? (
        <div className="embed-container">
          <iframe
            width="960"
            height="720"
            src={embedUrl}
            title="quicksight-dashboard">
          </iframe>
        </div>
      ) : (
        <p>Loading Dashboard...</p>
      )}
    </div>
  );
}

// Authenticatorコンポーネントでラップし、Google認証のみを指定
function App() {
  return (
    <Authenticator socialProviders={['google']}>
      {({ signOut, user }) => (
        <MainApp signOut={signOut} user={user} />
      )}
    </Authenticator>
  );
}

export default App;
